import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function load(path) {
	return resolve => require(['./views/' + path + '.vue'], resolve)
}

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			component: load('Mainpage')
		},
		{
			path: '/login',
			component: load('Login'),
		},
		{
			path: '/create',
			component: load('CreateApplication'),
		},
		{
			path: '/impressum',
			component: load('Impressum')
		},
		{
			path: '/devblog',
			component: load('Devblog')
		},
		{
			path: '/applications',
			alias: '/application',
			component: load('Applications')
		},
		{
			path: '/application/:id',
			name: 'application',
			props: true,
			component: load('Application')
		},
		{
			path: '*',
			component: load('NotFound')
		},
	],
})
